import { createSelector } from 'reselect'

const getState = state => state.Lesson.Builder.Main

const getActiveSlideId = createSelector(
  [getState],
  state => state.activeSlideId
)

export const getActiveSlide = createSelector([state => state], state => {
  const activeSlideId = state.Lesson.Builder.Main.activeSlideId
  const activeSlide =
    state.PresentationStore.slides.entities.slides[activeSlideId]
  return activeSlide
})

const isDragging = createSelector([getState], state => state.isDragging)

const isSettingsModalOpened = state => getState(state).settingsModalOpened

const getCreateSlideDialog = state => getState(state).createSlideDialog

const getEditSlideDialog = state => getState(state).editSlideDialog

export {
  getState as getBuilderState,
  getActiveSlideId,
  isDragging,
  isSettingsModalOpened,
  getCreateSlideDialog,
  getEditSlideDialog
}
